import React from 'react';
const ReactIcon = () => {
  return <img src='/skill-icons/react.png' alt='react-logo' />;
};

export default ReactIcon;
